<div *ngIf="showRotatePrompt"
  class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-90 p-4">

  <!-- Rotate Icon with animation -->
  <mat-icon class="text-white text-5xl animate-spin-slow">rotate_right</mat-icon>

  <p class="mt-4 text-center text-lg text-white">
    please rotate your device to portrait mode.
  </p>
</div>
